import React, { useState, useEffect } from "react";
import Combobox from "react-widgets/Combobox";
import "react-widgets/styles.css";
export default function UpdateAppointmentModal({
  isOpen,
  appointment,
  customerList,
  statusList,
  onSave,
  onClose,
}) {
  const [initialAppointment, setInitialAppointment] = useState({
    id: "",
    refferenceCode: "",
    date: "",
    startTime: "",
    endTime: "",
    services: [],
    staffName: "",
    client: "",
    status: "",
  });
  useEffect(() => {
    setInitialAppointment(appointment);
  }, [appointment]);
  const onSelectCustomer = (value) => {
    setInitialAppointment((prev) => ({
      ...prev,
      client: value.id,
    }));
  };
  // Clears form fields
  const onChangeStatus = (status) => {
    setInitialAppointment((prev) => ({
      ...prev,
      status: status,
    }));
  };
  // Handle save
  const handleSave = (e) => {
    e.preventDefault();

    onSave(initialAppointment); // send back to parent
  };
  const hanleClose = () => {
    setInitialAppointment(null);
    onClose();
  };
  if (initialAppointment == null || initialAppointment == {})
    return <div></div>;
  return (
    <div className={`  modal  ${isOpen ? "show" : ""}`} tabindex="-1">
      <div className="modal-dialog modal-lg  modal-dialog-centered">
        <div className="modal-content w-100">
          <div className="modal-header">
            <h5 className="modal-title">Update appointment</h5>
          </div>
          <div className="modal-body ">
            <div className="container">
              <div className="row  m-1">
                <div className="col-6 mb-3">
                  <label className="form-label">Reference :</label>
                  <label className="form-label ">
                    {appointment?.refferenceCode || ""}
                  </label>
                </div>
                <div className="col-6 mb-3 ">
                  <label className="form-label ">Date :</label>
                  <label className="form-label">{appointment?.date}</label>
                </div>

                <div className="col-6 mb-3">
                  <label className="form-label ">Start Time :</label>
                  <label className="form-label ">
                    {initialAppointment?.startTime}
                  </label>
                </div>

                <div className="col-6 mb-3">
                  <label className="form-label ">End Time :</label>
                  <label className="form-label ">
                    {initialAppointment?.endTime}
                  </label>
                </div>

                <div className="col-6 mb-3">
                  <label className="form-label ">Staff :</label>
                  <label className="form-label ">
                    {initialAppointment.staffName}
                  </label>
                </div>

                <div className="col-6 mb-3">
                  <div className="row">
                    <div className=" col-4 ">Services :</div>
                    <div className=" col-8">
                      {initialAppointment?.services?.map((s) => (
                        <div key={s.id}>{s.name}</div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="col-6 mb-3 form-control-container ">
                  <label className="form-label form-control-label">
                    Customer
                  </label>
                  <Combobox
                    onChange={(value) => onSelectCustomer(value)}
                    data={customerList.slice(1)}
                    dataKey="id"
                    textField="name"
                    value={initialAppointment.client}
                    containerClassName={" form-combobox "}
                  />
                </div>
                <div className="col-6 mb-3 form-control-container">
                  <label className="form-label form-control-label">
                    Status :
                  </label>
                  <label className="form-label">
                    <Combobox
                      onChange={(value) => onChangeStatus(value)}
                      data={statusList}
                      dataKey="id"
                      textField="name"
                      value={initialAppointment.status}
                      containerClassName={" form-combobox"}
                      autoComplete="off"
                    />
                  </label>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-end modal-footer mt-4 mb-3">
              <button
                type="submit"
                className="btn btn-secondary me-2"
                onClick={() => hanleClose()}
              >
                Cancel
              </button>{" "}
              <button
                type="submit"
                className="btn btn-primary"
                onClick={(e) => handleSave(e)}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
